var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Status=default",
    clipPath: "url(#clip0_9146_80474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic restart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 2.00007C9.91166 1.99882 9.82395 2.01514 9.74197 2.04808C9.65999 2.08102 9.58538 2.12993 9.52247 2.19196C9.45955 2.25399 9.4096 2.3279 9.3755 2.40941C9.3414 2.49091 9.32384 2.57838 9.32384 2.66673C9.32384 2.75508 9.3414 2.84255 9.3755 2.92406C9.4096 3.00556 9.45955 3.07948 9.52247 3.14151C9.58538 3.20354 9.65999 3.25244 9.74197 3.28539C9.82395 3.31833 9.91166 3.33465 10 3.3334C13.6897 3.3334 16.6667 6.31038 16.6667 10.0001C16.6667 13.6898 13.6897 16.6667 10 16.6667C6.31031 16.6667 3.33333 13.6898 3.33333 10.0001C3.33333 8.43356 3.87236 6.99796 4.77344 5.86205L6 7.3334L7.33333 2.66673L2.66667 3.3334L3.91146 4.82689C2.72444 6.22344 2 8.02793 2 10.0001C2 14.4104 5.58969 18.0001 10 18.0001C14.4103 18.0001 18 14.4104 18 10.0001C18 5.58976 14.4103 2.00007 10 2.00007Z",
    fill: "#2894FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9146_80474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.6b5e6aaa3e041822b57a99102ce25a61.svg";
export { ForwardRef as ReactComponent };